<template>
  <div>
    <!-- HEADER & BADGE -->
    <div class="row">
      <api-header-badge-section :id="id" :operation="operation">
        <span class="grow" />
        <span :id="id + '-' + type" class="flex flex-row items-center pill large" :type="type"
          ><v-icon :name="type === 'callback' ? 'toggle-solid' : 'webhook-solid'" :size="-6" class="white-color" />{{
            type
          }}</span
        >
      </api-header-badge-section>
    </div>
    <!-- REQUEST BODY -->
    <api-request-body-section
      v-if="operation.requestBody"
      :id="`${operation.id}-req-body`"
      :contents="operation.requestBody"
      callback
    />
    <!-- RESPONSES -->
    <api-response-section
      v-if="operation.responses"
      :id="`${operation.id}-responses`"
      :responses="operation.responses"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { CallbackObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import { VIcon } from '@vonage/vivid-vue';
import ApiHeaderBadgeSection from '@/components/api/content/common/ApiHeaderBadgeSection.vue';
import ApiRequestBodySection from '@/components/api/content/operations/ApiRequestBodySection.vue';
import ApiResponseSection from '@/components/api/content/operations/ApiResponseSection.vue';

defineProps({
  type: { type: String as PropType<'callback' | 'webhook'>, default: 'callback' },
  id: { type: String, required: true },
  operation: { type: Object as PropType<CallbackObject>, required: true },
});
</script>

<style scoped lang="scss">
.white-color {
  color: var(--vvd-color-canvas);
}
.pill {
  color: var(--vvd-color-canvas);
  gap: 4px;
  padding: 4px 8px !important;

  &[type='callback'] {
    background-color: #008000;
  }

  &[type='webhook'] {
    background-color: #d34204;
  }
}
</style>
